export default {
    home: {
      buenosDias: "Buenos días",
      buenasTardes: "Buenas tardes",
      buenasNoches: "Buenas noches",
      reparaciones: "Reparaciones",
      servicios: "Servicios",
      atrasados: "Atrasados",
      reclamos: "Reclamos",
      tituloRep: "Reparaciones en taller",
      tituloServ: "Servicios en terreno",
      verMas: "Ver más",  
    },
    sidebar: {
      dashboard: "Dashboard",
      reparaciones : "Reparaciones",
      servicios : "Servicios",
      reclamos : "Reclamos",
      eliminadas : "Órdenes eliminadas",
      clientes : "Clientes",
      proveedores : "Proveedores",
      obras : "Obras",
      stock: "Stock",
      repuestos: "Repuestos",
      compras: "Compras",
      remitos: "Remitos",
      stockPorSucursal: "Stock por sucursal",
      familias: "Familias",
      equipos: "Equipos",
      listado: "Listado",
      tiposEquipo: "Tipos de equipos",
      marcas: "Marcas",
      modelos: "Modelos",
      porUbicacion: "Por ubicación",
      checklists: "Checklists",
      planesMantenimiento: "Planes de mantenimiento",
      rma: "RMA",
      mantVehicular: "Mant. vehicular",
      despachos: "Despachos",
      planillaGasoilAceite: "Planilla gasoil/aceite",
      cambiosAceite: "Cambios de aceite",
      alertasConsumo: "Alertas de consumo",
      proximosMantenimientos: "Próximos mantenimientos",
      informes: "Informes",
      habilitaciones: "Habilitaciones",
      planActual: "Plan actual",
      vencePlan: "Vence el "
    },
    wppCard: {
      titulo: "Módulo de Whatsapp",
      textSubirPlan: "Tu plan de SatWeb no incluye la funcionalidad de Whatsapp. Para utilizarlo debes suscribirte a otro plan",
      tituloConfig: "CONFIGURACIÓN DE WHATSAPP",
      textNumSatweb: "Se ha configurado el número de satweb para el módulo de whatsapp",
      textConfig: "Por favor asegúrate de configurar el módulo de whatsapp para poder utilizarlo",
      comprarNumPropio: "Comprar número propio",
      pregCerrarSesion: "¿Desea cerrar la sesión de Whatsapp?",
      vencido: "Vencido",
      vence: "Vence el ",
      servGratis: "Utilice el servicio gratuito incluido en su plan de SatWeb",
      nroSatweb: "Los mensajes serán enviados a sus clientes utilizando nuestro número de Whatsapp identificado como ¨SatWeb¨",
      nroPropio: "Utilice su propio número de Whatsapp",
      txtNroPropio: "Los mensajes serán enviados a sus clientes utilizando su propio número de Whatsapp",
      gratis: "Servicio gratuito",
      premium: "Servicio premium", 
      msgError: "La api key o el id de la instancia de whatsapp es inválido. Asegurate de haberlos escrito correctamente"
    },
    calendario: {
      titulo:"Calendario",
      ver: "Ver calendario",
      msgNoOrdenes: "No hay órdenes pendientes para la fecha seleccionada",
      reparacion: "Reparación",
      servicio: "Servicio",
      cambiarTecnico: "Seleccionar otro técnico",
      totalOrdenes: "Total de órdenes",
      totalRep: "Total de reparaciones",
      totalServ: "Total de servicios"
    },
    tableroMando:{
      titulo: "Tablero de mando",
      nuevasHoy: "Nuevas órdenes de hoy",
      urgentes: "Órdenes urgentes",
      ver: "Ver tablero",
      mttr: "MTTR",
      mapaCalor: "Mapa de calor"
    },
    mttr:{
      desc: "El MTTR significa Mean Time To Repair por sus siglas en inglés, siendo este el tiempo medio de orden entre el periodo que el equipo entra en parada programada por mantenimiento o parada por falla funcional, hasta que este es puesto nuevamente en servicio",
      btnEquipo: "Seleccionar un equipo",
      año: "Año"
    },
    mapa:{
      titulo: "¿Dónde están mis técnicos?",
      ver: "Ver mapa"
    },
    formats: {
      fechaLarga: "dddd D [de] MMMM [de] YYYY"
    }
}